module.exports = __webpack_public_path__ + "static/media/consulting_about_4.98449132.webp";